import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { sharedStorage } from '../../../common/storage/storage';

type WfAuthStore = {
  authenticated: boolean;
  serverCommunicationErrorExists: boolean;
  setAuthenticated: (authenticated: boolean) => void;
};

export const useWfAuthStore = create<WfAuthStore>()(
  persist<WfAuthStore>(
    (set, _get) => ({
      authenticated: false,
      serverCommunicationErrorExists: false,
      setAuthenticated: (authenticated: boolean) => set({ authenticated }),
    }),
    {
      name: 'wf-auth',
      storage: createJSONStorage(() => sharedStorage),
    }
  )
);
